"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLinksFactory = void 0;
class AdminLinksFactory {
    static sample(links) {
        return {
            uploadJobCsv: {
                href: 'https://example.com/uploadJobCsv',
                templated: false,
            },
            collection: { href: 'https://example.com/collection', templated: false },
            createCollection: {
                href: 'https://example.com/createCollection',
                templated: false,
            },
            getAccounts: {
                href: 'https://example.com/accounts',
                templated: false,
            },
            getAccount: {
                href: 'https://example.com/accounts',
                templated: false,
            },
            deleteAccount: {
                href: 'https://example.com/accounts',
                templated: false,
            },
            createAccount: {
                href: 'https://example.com/accounts',
                templated: false,
            },
            createUser: {
                href: 'https://example.com/users',
                templated: false,
            },
            deleteUser: {
                href: 'https://example.com/users/{id}',
                templated: true,
            },
            updateUser: {
                href: 'https://example.com/users/{id}',
                templated: true,
            },
            uploadCustomMetadata: {
                href: 'https://example.com/custom-metadata/{?file}',
                templated: true,
            },
            updateAccounts: {
                href: 'https://example.com/accounts',
                templated: false,
            },
            myCollections: {
                href: 'https://example.com/myCollections',
                templated: false,
            },
            mySavedCollections: {
                href: 'https://example.com/mySavedCollections',
                templated: false,
            },
            userSharedBookmarkedCollections: {
                href: 'https://example.com/myCollections?type=USER_SHARED',
                templated: false,
            },
            boclipsSharedCollections: {
                href: 'https://example.com/myCollections?type=BOCLIPS_SHARED',
                templated: false,
            },
            searchCollections: {
                href: 'https://example.com/searchCollections',
                templated: false,
            },
            searchAllCollections: {
                href: 'https://example.com/searchAllCollections',
                templated: false,
            },
            video: { href: 'https://example.com/video', templated: false },
            searchVideos: {
                href: 'https://example.com/searchVideos',
                templated: false,
            },
            jobs: { href: 'https://example.com/jobs', templated: false },
            jobDetails: { href: 'https://example.com/jobDetails', templated: false },
            orders: { href: 'https://example.com/orders', templated: false },
            userOrders: { href: 'https://example.com/userOrders', templated: false },
            exportOrders: {
                href: 'https://example.com/exportOrders',
                templated: true,
            },
            orderCsvTemplate: {
                href: 'https://example.com/orders/csv-template',
                templated: false,
            },
            order: { href: 'https://example.com/order', templated: false },
            placeOrder: { href: 'https://example.com/placeOrder', templated: false },
            httpFeeds: { href: 'https://example.com/httpFeeds', templated: false },
            channels: { href: 'https://example.com/channels', templated: false },
            channel: { href: 'https://example.com/channel', templated: false },
            channelsSignedUploadLink: {
                href: 'https://example.com/channelsSignedUploadLink',
                templated: false,
            },
            contract: { href: 'https://example.com/contract', templated: false },
            createContracts: {
                href: 'https://example.com/createContracts',
                templated: false,
            },
            createContractsSignedUploadLink: {
                href: 'https://example.com/createContractsSignedUploadLink',
                templated: false,
            },
            contracts: { href: 'https://example.com/contracts', templated: false },
            legalRestrictions: {
                href: 'https://example.com/legalRestrictions',
                templated: false,
            },
            youtubeFeeds: {
                href: 'https://example.com/youtubeFeeds',
                templated: false,
            },
            createHttpFeed: {
                href: 'https://example.com/createHttpFeed',
                templated: false,
            },
            distributionMethods: {
                href: 'https://example.com/distributionMethods',
                templated: false,
            },
            trackPageRendered: {
                href: 'https://example.com/trackPageRendered',
                templated: false,
            },
            trackPlatformInteractedWith: {
                href: 'https://example.com/trackPlatformInteractedWith',
                templated: false,
            },
            createSearchQueryCompletionsSuggestedEvent: {
                href: 'https://example.com/createSearchQueryCompletionsSuggestedEvent',
                templated: false,
            },
            subjects: { href: 'https://example.com/subjects', templated: false },
            marketSegmentSubjects: {
                href: 'https://example.com/subjects{?marketSegment}',
                templated: true,
            },
            disciplines: {
                href: 'https://example.com/disciplines',
                templated: false,
            },
            allDisciplines: {
                href: 'https://example.com/disciplines?visibility=all',
                templated: false,
            },
            searchAccessRules: {
                href: 'https://example.com/searchAccessRules',
                templated: false,
            },
            reportAccessExpired: null,
            videoTypes: { href: 'https://example.com/videoTypes', templated: false },
            contentCategories: {
                href: 'https://example.com/contentCategories',
                templated: false,
            },
            ingestVideos: {
                href: 'https://example.com/ingestVideos',
                templated: false,
            },
            tags: { href: 'https://example.com/tags', templated: false },
            marketingStatuses: {
                href: 'https://example.com/marketingStatuses',
                templated: false,
            },
            ageRanges: { href: 'https://example.com/ageRanges', templated: false },
            suggestions: {
                href: 'https://example.com/suggestions',
                templated: false,
            },
            ingestVideoStatuses: {
                href: 'https://example.com/ingestVideoStatuses',
                templated: false,
            },
            contractLegalRestrictions: {
                href: 'https://example.com/contractLegalRestrictions',
                templated: false,
            },
            getCaptions: {
                href: 'https://example.com/getCaptions',
                templated: false,
            },
            contentWarnings: {
                href: 'https://example.com/contentWarnings',
                templated: false,
            },
            attachmentTypes: {
                href: 'https://example.com/attachmentTypes',
                templated: false,
            },
            getContentPackages: {
                href: 'https://example.com/getContentPackages',
                templated: false,
            },
            getContentPackage: {
                href: 'https://example.com/getContentPackage',
                templated: false,
            },
            updateContentPackage: {
                href: 'https://example.com/updateContentPackage',
                templated: false,
            },
            createContentPackage: {
                href: 'https://example.com/createContentPackage',
                templated: false,
            },
            categories: {
                href: 'https://example.com/categories',
                templated: false,
            },
            isUserActive: {
                href: 'https://example.com/isUserActive',
                templated: false,
            },
            currentUser: {
                href: 'https://example.com/currentUser',
                templated: false,
            },
            cart: { href: 'https://example.com/cart', templated: false },
            updateVideos: {
                href: 'https://example.com/videos',
                templated: false,
            },
            accountUsers: {
                href: 'https://example.com/accounts/{id}/users{?query}',
                templated: true,
            },
            accountBulkUsers: {
                href: 'https://example.com/accounts/{id}/users/search',
                templated: true,
            },
            accountContentPackages: {
                href: 'https://example.com/accounts/{id}/contentPackages',
                templated: true,
            },
            updateAccountContentPackages: {
                href: 'https://example.com/accounts/{id}/contentPackages',
                templated: true,
            },
            educationLevels: {
                href: 'https://example.com/education-levels',
                templated: false,
            },
            promotedForCollections: {
                href: 'https://example.com/v1/collections?projection=list&discoverable=true&page=0&size=30{?promotedFor}',
                templated: true,
            },
            getThemesByIds: {
                href: 'https://example.com//alignments/themes{?id}',
                templated: true,
            },
            getThemesByProvider: {
                href: 'https://example.com//alignments/{provider}/themes',
                templated: true,
            },
            getAllProviders: {
                href: 'https://example.com/alignments/providers',
                templated: false,
            },
            getProviderById: {
                href: 'https://example.com/alignments/providers/{providerId}',
                templated: true,
            },
            createProvider: {
                href: 'https://example.com/alignments/providers/{providerId}',
                templated: false,
            },
            createThemeLogoSignedUploadLink: {
                href: 'https://example.com/createThemeLogoSignedUploadLink',
                templated: false,
            },
            getThemesByProviderAndId: {
                href: 'https://example.com/alignments/{provider}/themes/{id}',
                templated: true,
            },
            uploadProviderMapping: {
                href: 'https://example.com/alignments/themes/{?file}',
                templated: true,
            },
            ordersWithinDates: {
                href: 'https://example.com/orders{?order_created_from,order_created_to}',
                templated: true,
            },
            learningOutcomes: {
                href: 'https:example.com/learning_outcomes/{videoId}',
                templated: true,
            },
            assessmentQuestions: {
                href: 'https:example.com/assessment_questions/{videoId}',
                templated: true,
            },
            prices: {
                href: 'https://example.com/accounts/{id}/prices',
                templated: true,
            },
            getAccountApiClient: {
                href: 'https://example.com/accounts/{id}/api-client',
                templated: true,
            },
            getSimilarAccounts: {
                href: 'https://example.com/accounts/{id}/find-similar',
                templated: true,
            },
            boclipsWebAppAccess: {
                href: 'https://example.com/users/_self',
                templated: false,
            },
            classroomWebAppAccess: {
                href: 'https://example.com/users/_self',
                templated: false,
            },
            myLicensedContent: {
                href: 'https://example.com/users/6eb42a4f-e868-4ee9-b14e-075a88174cbf/licensed-content',
                templated: false,
            },
            myAccountLicensedContent: {
                href: 'https://example.com/users/6eb42a4f-e868-4ee9-b14e-075a88174cbf/account-licensed-content',
                templated: false,
            },
            trackCollectionShareLink: {
                href: 'https://example.com/collections/{id}/track-share-link',
                templated: true,
            },
            trackVideoShareLink: {
                href: 'https://example.com/videos/{id}/track-share-link',
                templated: true,
            },
            searchSchools: {
                href: 'https://example.com/schools?countryCode=USA{&query,state}',
                templated: true,
            },
            searchDistricts: {
                href: 'https://example.com/districts?countryCode=USA{&query,state}',
                templated: true,
            },
            ...links,
        };
    }
}
exports.AdminLinksFactory = AdminLinksFactory;
//# sourceMappingURL=AdminLinksFactory.js.map